import React from 'react';
import Translate from "../../../shared/language/Translate";
import {Button} from 'reactstrap';
import {TabPanel, TabView} from "primereact/tabview";
import {ASSET_CATEGORY, PAGE_MODE, REQUEST_TYPE} from "../../../shared/utils/Constants";
import Toolbar from "../../../shared/component/toolbar/Toolbar";
import {AvForm} from 'availity-reactstrap-validation';
import GeneralUtils from "../../../shared/utils/GeneralUtils";
import AuditEvent from "../../administration/AuditEvent";
import MobileColumn from '../../../shared/component/dataTable/columns/MobileColumn.json';
import Attachment from "../../request/attacheddocument/Attachment";
import HsmDocumentService from "../../../shared/service/HsmDocumentService";
import MobileSave from './MobileSave';
import MobileService from '../../../shared/service/MobileService';

export default class Mobile extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            pageMode: null,
            documentIdList:[]
        };
        this.service = new MobileService();
        this.documentService= new HsmDocumentService();
    }

    render() {
        return (
            <AvForm onValidSubmit={this.save} beforeSubmitValidation={() => this.setState({activeIndex: 0})}>
                {this.state.displayButton !== false &&
                <Toolbar
                    display={GeneralUtils.getDialogToolbarDisplay(MobileColumn.name, this.state.pageMode)}>
                    <div className="p-toolbar-group-right">
                        <Button color="primary" type="submit" className="float-right">
                            <Translate contentKey="entity.action.save">Kaydet</Translate>
                        </Button>
                        <Button color="primary" className="float-right"
                                onClick={this.props.closeDisplayDialog}>
                            <Translate contentKey="entity.action.save">Vazgeç</Translate>
                        </Button>
                    </div>
                </Toolbar>
                }
                <TabView activeIndex={this.state.activeIndex} onTabChange={(e) => this.setState({activeIndex: e.index})}
                         renderActiveOnly={false}>
                    <TabPanel header="Varlık Bilgileri"
                              rightIcon="pi pi-user">
                        <MobileSave ref={(elem) => this.refMobileSave = elem}/>
                    </TabPanel>

                    <TabPanel
                         header={GeneralUtils.isNullOrEmpty(this.state.attachmentLength) ? "Dokümanlar" : "Dokümanlar (" + this.refAttachedDocument.getData().length + ")"}
                        disabled={this.state.disabledTabs}
                        headerClassName={this.state.disabledTabs && 'displayNone'}>

                        <Attachment ref={elem => this.refAttachedDocument = elem}
                                    setAttachmentLength={(length) => this.setState({attachmentLength: length})}
                                    setDocumentId={(documentId)=>{
                                        let documentIdList = this.state.documentIdList;
                                        documentIdList.push(documentId);
                                        this.setState({documentIdList});
                                    }
                                    }
                                    deleteDocumentId={(documentId)=>{
                                        let documentIdList = this.deleteDocumentId(documentId);
                                        this.setState({
                                            documentIdList
                                        });
                                    }}
                        />
                    </TabPanel>

                    <TabPanel header="Tarihçe" rightIcon="pi pi-user"
                              disabled={this.state.pageMode === PAGE_MODE.CREATE}
                              headerClassName={this.state.pageMode === PAGE_MODE.CREATE && 'displayNone'}>
                        <AuditEvent ref={elem => this.refAuditEvent = elem} objectName={MobileColumn.name}/>
                    </TabPanel>
                </TabView>
            </AvForm>
        );
    }


    setData = (data, pageMode, displayButton) => {
        this.setState({pageMode: pageMode, activeIndex: 0, displayButton: displayButton});
        this.refMobileSave.setData(Object.assign({}, data), pageMode, displayButton);
        this.refAttachedDocument.setData(Object.assign({}, data), REQUEST_TYPE.MOBILE, pageMode, null);
        this.refAuditEvent.setData(MobileColumn.name, data.id);
    }


    save = () => {
        let mobile = this.refMobileSave.getData();
        let data = {mobile: mobile}
        if (!GeneralUtils.isNullOrEmpty(mobile.id)) {
            this.service.update(data).then((response) => {
                data.mobile = GeneralUtils.addUpdateInfo(data.mobile);
                if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)) {
                    if(!GeneralUtils.isNullOrEmpty(this.state.documentIdList)) {
                        this.documentService.createOrUpdateHsmAttachDocument(REQUEST_TYPE.MOBILE, response.mobile.id, this.state.documentIdList);
                    }
                    if (this.props.refresh) {
                        this.props.refresh();
                    }
                    this.props.closeDisplayDialog();
                }
            });
        } else {
            data.mobile = GeneralUtils.addCreateInfo(data.mobile);

            this.service.create(data)
                .then(response => {
                    if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)) {
                        if(!GeneralUtils.isNullOrEmpty(this.state.documentIdList)) {
                            this.documentService.createOrUpdateHsmAttachDocument(REQUEST_TYPE.MOBILE, response.mobile.id, this.state.documentIdList);
                        }
                        if (this.props.refresh) {
                            this.props.refresh();
                        }
                        if (this.props.setMobile) {
                            this.props.setMobile(response.mobile);
                        }
                        this.props.closeDisplayDialog();
                    }
                });
        }
    }

    addNew = () => {
        this.setState({anchestorAssetTag: null, pageMode: PAGE_MODE.CREATE, activeIndex: 0});
        this.refMobileSave.clearData();
        this.refMobileSave.findDistrictByChangedCityId(1);
        this.refMobileSave.setPageMode(PAGE_MODE.CREATE);
    }

    setPageMode = (pageMode) => {
        this.refMobileSave.setPageMode(pageMode);
        this.setState({pageMode: pageMode})
    }

    deleteDocumentId(documentId) {
        let documentIdList = this.state.documentIdList;
        return documentIdList.filter(function (el) {
            return el != documentId;
        });
    }
}
